/**
 * EWM-663 — resolve the customer-facing / deliverable email address.
 *
 * commercetools' default `email` is uniqueness-mangled with account/BU
 * prefixes (`CN1---sdnz---N813998@x`, see EWM-448). The clean address lives in
 * the `customerEmail` custom field. Prefer it for anything a customer SEES or
 * that is SENT to a mailbox; fall back to the raw `email` only when
 * `customerEmail` is null/empty so the value is never silently blank. Uses `||`
 * (not `??`) so an empty-string `customerEmail` also falls back.
 *
 * Mirrors the BFF helper of the same name
 * (`commerce-commercetools/utils/getDeliverableEmail.ts`). NOT for identity /
 * self-detection keys — those keep the raw `email`.
 */
export const getDeliverableEmail = (
  account: { customerEmail?: string; email?: string } | undefined,
): string | undefined => account?.customerEmail || account?.email;
